import React, { useState } from "react";
import TopNavigation from "./components/TopNavigation";
import Bio from "./components/Bio";
import Music from "./components/Music";
import Photo from "./components/Photos";
import Video from "./components/Videos";
import "./App.css";

function App() {
  const [activeSection, setActiveSection] = useState("Music");

  return (
    <div className="flex flex-col min-h-screen text-gray-100 bg-black">
      <TopNavigation setActiveSection={setActiveSection} />
      <main className="flex-grow mt-14 w-full sm:max-w-lg mx-auto sm:max-w-lg">
        <div className={`${activeSection !== "Music" ? "hidden" : ""}`}>
          <Music />
        </div>
        {activeSection === "Bio" && <Bio />}
        {activeSection === "Photo" && <Photo />}
        {activeSection === "Video" && <Video />}
      </main>
    </div>
  );
}

export default App;
